
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useChat } from '../contexts/ChatContext'
import { useSocket } from '../contexts/SocketContext'
import { chatService } from '../services/api'
import './MinhasConversas.css'

function MinhasConversas() {
    const { openChat } = useChat()
    const { socket } = useSocket()
    const [conversas, setConversas] = useState([])
    const [loading, setLoading] = useState(true)
    const [erro, setErro] = useState(null)
    const [imageErrors, setImageErrors] = useState({})

    const handleImageError = (id) => {
        setImageErrors(prev => ({ ...prev, [id]: true }));
    };

    useEffect(() => {
        carregarConversas()
    }, [])

    useEffect(() => {
        if (!socket) return

        const handleNovaMensagem = (msg) => {
            // Recarregar a lista quando chegar uma nova mensagem
            carregarConversas()
        }

        socket.on('nova_mensagem', handleNovaMensagem)
        return () => {
            socket.off('nova_mensagem', handleNovaMensagem)
        }
    }, [socket])

    const carregarConversas = async () => {
        try {
            const response = await chatService.listarConversas()
            setConversas(response.conversas)
        } catch (error) {
            console.error('Erro ao carregar conversas:', error)
            setErro('Não foi possível carregar suas conversas.')
        } finally {
            setLoading(false)
        }
    }

    const getFotoUrl = (url) => {
        if (!url) return '';
        if (url.startsWith('http')) return url;
        return `${import.meta.env.VITE_API_URL || 'http://localhost:3001'}${url}`;
    }

    if (loading) return <div className="loading">Carregando conversas...</div>

    return (
        <div className="minhas-conversas-container">
            <h1>Minhas Mensagens</h1>

            {erro && <div className="erro">{erro}</div>}

            {conversas.length === 0 && !loading && !erro ? (
                <div className="empty-state">
                    <p>Você ainda não iniciou nenhuma conversa.</p>
                    <Link to="/anuncios" className="btn btn-primary">Ver Anúncios</Link>
                </div>
            ) : (
                <div className="conversas-list">
                    {conversas.map(conversa => (
                        <div
                            key={conversa.id}
                            className="conversa-card"
                            onClick={() => openChat({
                                id: conversa.outro_usuario_id,
                                nome: conversa.outro_usuario_nome,
                                foto: getFotoUrl(conversa.outro_usuario_foto)
                            })}
                        >
                            <div className="conversa-avatar">
                                {conversa.outro_usuario_foto && !imageErrors[conversa.id] ? (
                                    <img 
                                        src={getFotoUrl(conversa.outro_usuario_foto)} 
                                        alt={conversa.outro_usuario_nome} 
                                        onError={() => handleImageError(conversa.id)}
                                    />
                                ) : (
                                    <div className="avatar-placeholder">
                                        {conversa.outro_usuario_nome?.charAt(0)}
                                    </div>
                                )}
                            </div>
                            <div className="conversa-info">
                                <h3>{conversa.outro_usuario_nome}</h3>
                                <p className="ultima-mensagem">
                                    {conversa.lida ? conversa.conteudo : <strong>{conversa.conteudo}</strong>}
                                </p>
                            </div>
                            <div className="conversa-meta">
                                <span className="data">
                                    {new Date(conversa.criado_em).toLocaleDateString()}
                                </span>
                                {!conversa.lida && <span className="badge-nao-lida">•</span>}
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

export default MinhasConversas
